module.exports = __webpack_public_path__ + "bed-subtitle-bg.d8dfdbee.png";